import * as React from "react";
import MachineData from "./MachineData";
import UserData from "./UserData";
import GroupData from "./GroupData";
function Details({ asset }) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, asset.details.type === "machine" && /* @__PURE__ */ React.createElement(MachineData, { machineAsset: asset }), asset.details.type === "user" && /* @__PURE__ */ React.createElement(UserData, { userAsset: asset }), asset.details.type === "group" && /* @__PURE__ */ React.createElement(GroupData, { groupAsset: asset }));
}
export default Details;
